import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_BASE_URL } from "../../Config";
import Swal from "sweetalert2";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import toast, { Toaster } from "react-hot-toast";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { getSessionStorage } from "../../Helper";
// Material UI components
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import { useTheme } from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

function PickupRequest() {
  const showSidebar = useSelector((state) => state.sidebar.showSidebar);

  const [errors, setErrors] = useState({});
  const cid = getSessionStorage("cid");

  // Form state
  const [accode, setAccode] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [originPincode, setOriginPincode] = useState("");
  const [destinationPincode, setDestinationPincode] = useState("");
  const [consignor, setConsignor] = useState("");
  const [consignorList, setConsignorList] = useState([]);
  const [consignee, setConsignee] = useState("");
  const [consigneeList, setConsigneeList] = useState([]);
  const [mobile1, setMobile1] = useState("");
  const [noOfBox, setNoOfBox] = useState("");
  const [pickupsheetDate, setPickupsheetDate] = useState("");
  const [description, setDescription] = useState("");
  const [consignorName, setConsignorName] = useState("");
  const [originPincodes, setOriginPincodes] = useState([]);
  const [isMobileDisabled, setIsMobileDisable] = useState(false);
  const [destinationPincodes, setDestinationPincodes] = useState([]);
  const [noOfPieces, setNoOfPieces] = useState("");

  // Hidden fields
  const [destinationId, setDestinationId] = useState("");
  const [destinationPincodeHidden, setDestinationPincodeHidden] = useState("");
  const [originId, setOriginId] = useState("");
  const [originPincodeHidden, setOriginPincodeHidden] = useState("");

  // Validation states
  const [isValidOriginPincode, setIsValidOriginPincode] = useState(true);
  const [isValidDestinationPincode, setIsValidDestinationPincode] = useState(true);
  const [isValidMobile, setIsValidMobile] = useState(true);
  const [deliveryBid, setDeliveryBid] = useState("");
  const [pickupBid, setPickupBid] = useState("");
  const [selectedGstAddresses, setSelectedGstAddresses] = useState([]);
  const [isLoadingGst, setIsLoadingGst] = useState(false);

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [partyForm, setPartyForm] = useState({
    gstNo: "",
    subAccountName: "",
    pinCode: "",
    address1: "",
    cityName: "",
    districtName: "",
    areaName: "",
    stateName: "",
    customerCategory: "",
    mobileNo: "",
  });

  // Validation states for party form
  const [partyErrors, setPartyErrors] = useState({});

  const today = new Date().toISOString().split("T")[0];

  // Typeahead refs
  const originTypeaheadRef = useRef(null);
  const destinationTypeaheadRef = useRef(null);

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  // Fetch customer list on component mount
  useEffect(() => {
    fetchCustomerList();
    // Set default pickup date
    const today = new Date().toISOString().split("T")[0];
    setPickupsheetDate("");
  }, []);

  // Fetch customer list from API
  const fetchCustomerList = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/pickupReq/getCustomerList`, {
        params: {
          cid: getSessionStorage("cid"),
          username: getSessionStorage("accode"),
        },
      });
      if (response.status === 200) {
        const customers = Object.entries(response.data).map(([value, label]) => ({
          value,
          label,
        }));

        setCustomerList(customers);
      }
    } catch (error) {
      console.error("Error fetching customer list:", error);
    }
  };

  // Fetch pincode suggestions from API
  const fetchPincodeSuggestions = async (query) => {
    if (!query || query.length < 6) {
      setOriginPincodes([]);
      setConsignorList([]);
      setConsignor("");
      setMobile1("");
      setConsignorName("");
      return [];
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/pickupReq/getSubPinMaster`, {
        params: {
          cid: sessionStorage.getItem("cid"),
          searchKey: query,
        },
      });

      if (response.status === 200) {
        const results = response.data.map((item) => ({
          id: item.delbid || item.id,
          originPincode: item.originPincode,
          area: item.area || "",
          city: item.city || "",
          statename: item.statename,
          gstvalue: item.gstvalue,
          gstapp: item.gstapp,
          zone: item.zone || "",
        }));
        setOriginPincodes(results);
        return results.map((item) => ({
          pincode: item.originPincode,
          area: item.area,
          city: item.city,
          state: item.statename,
          id: item.id,
          gstValue: item.gstvalue,
          gstApp: item.gstapp,
        }));
      }

      setOriginPincodes([]);
      setConsignorList([]);
      setConsignor("");
      setMobile1("");
      setConsignorName("");
      return [];
    } catch (error) {
      console.error("Error fetching pincode suggestions:", error);
      setOriginPincodes([]);
      setConsignorList([]);
      setConsignor("");
      setMobile1("");
      setConsignorName("");
      return [];
    }
  };

  // Fetch consignor list based on pincode
  const fetchConsignorList = async (pincode) => {
    if (!pincode) {
      setConsignorList([]);
      return;
    }

    try {
      const cid = sessionStorage.getItem("cid");
      const response = await axios.get(`${API_BASE_URL}/pickupReq/getSubMaster`, {
        params: {
          cid: cid,
          pincode: pincode,
          accode: getSessionStorage("accode"),
        },
      });

      if (response.status === 200 && response.data) {
        // Keep the same structure as API response
        const consignors = response.data.map((item) => ({
          subCode: item.subCode,
          acName: item.acName,
        }));
        setConsignorList(consignors);
      } else {
        setConsignorList([]);
        setConsignor("");
      }
    } catch (error) {
      console.error("Error fetching consignor list:", error);
      setConsignorList([]);
      setConsignor("");
    }
  };

  // Fetch mobile number based on consignor selection
  const fetchConsignorMobile = async (consignorId) => {
    if (!consignorId) return;
    try {
      const response = await axios.get(`${API_BASE_URL}/pickupReq/subDebtorDetails`, {
        params: {
          cid: getSessionStorage("cid"),
          subcode: consignorId,
        },
      });
      if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
        const consignor = response.data[0];

        // Check if mobile number exists and is not empty/null
        const mobile = consignor.SMOBILE || "";
        const consignorName = consignor.SACNAME || "";

        if (mobile && mobile.trim() !== "") {
          // Mobile number exists - set it and disable the field
          setConsignorName(consignorName);
          setMobile1(mobile);
        } else {
          // Mobile number is empty/null - clear the field and enable it for manual entry
          setConsignorName("");
          setIsMobileDisable("false");
          setMobile1("");
        }
      } else {
        // No data received - enable field for manual entry
        setConsignorName("");
        setIsMobileDisable("false");
        setMobile1("");
      }
    } catch (error) {
      console.error("Error fetching consignor mobile:", error);
      // On error - enable field for manual entry
      setConsignorName("");
      setIsMobileDisable("false");
      setMobile1("");
    }
  };

  // Fetch destination pincode suggestions from API
  const fetchDestinationPincodeSuggestions = async (query) => {
    if (!query || query.length < 6) {
      setDestinationPincodes([]);
      return [];
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/pickupReq/getSubPinMaster`, {
        params: {
          cid: sessionStorage.getItem("cid"),
          searchKey: query,
        },
      });

      if (response.status === 200) {
        const results = response.data.map((item) => ({
          id: item.delbid || item.id,
          destinationPincode: item.originPincode,
          area: item.area || "",
          city: item.city || "",
          statename: item.statename,
          gstvalue: item.gstvalue,
          gstapp: item.gstapp,
          zone: item.zone || "",
        }));
        setDestinationPincodes(results);
        return results.map((item) => ({
          pincode: item.destinationPincode,
          area: item.area,
          city: item.city,
          state: item.statename,
          id: item.id,
          gstValue: item.gstvalue,
          gstApp: item.gstapp,
        }));
      }

      setDestinationPincodes([]);
      return [];
    } catch (error) {
      console.error("Error fetching destination pincode suggestions:", error);
      setDestinationPincodes([]);
      return [];
    }
  };

  // Handle destination pincode selection
  const handleDestinationPincodeChange = (selected) => {
    if (selected && selected.length > 0) {
      const item = selected[0];
      setDestinationPincode(item.pincode);
      setDestinationId(item.id);
      setDestinationPincodeHidden(item.pincode);
      setIsValidDestinationPincode(true);
      // Fetch consignee list based on pincode
      fetchConsigneeList(item.pincode);
    } else {
      setDestinationPincode("");
      setDestinationId("");
      setDestinationPincodeHidden("");
      setConsigneeList([]);
    }
  };

  // Handle mobile number validation
  const handleMobileChange = (e) => {
    const value = e.target.value;
    setMobile1(value);
    const isValid = /^\d{10}$/.test(value);
    setIsValidMobile(isValid);
  };

  // Handle customer selection
  const handleCustomerChange = (e) => {
    setAccode(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all required fields
    if (
      !accode ||
      !originPincode ||
      !destinationPincode ||
      !consignor ||
      !mobile1 ||
      !noOfBox ||
      !pickupsheetDate
    ) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Form",
        text: "Please fill all required fields.",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    try {
      const formData = {
        accode: accode,
        destination: originPincode,
        destinationId: destinationId,
        destinationPincode: originPincode,
        consignee: consignor,
        mobile1: mobile1,
        origin: destinationPincode,
        originId: destinationId,
        originPincode: destinationPincode,
        noOfBox: noOfBox,
        noOfPieces: noOfPieces,
        pickupsheetDate: pickupsheetDate.split("-").reverse().join("/"),
        description: description,
        consignorName: consignor,
        deliveryBid: deliveryBid,
        pickupBid: pickupBid,
        cid: getSessionStorage("cid"),
        bid: "1",
        username: getSessionStorage("accode"),
      };

      const response = await axios.post(`${API_BASE_URL}/pickupReq/savePickupRequest`, formData);

      if (response.status === 200) {
        await Swal.fire({
          icon: "success",
          title: "Pickup Request Created Successfully",
          html: `Pickup Request No: <b>${response.data}</b>`,
          confirmButtonText: "OK",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });

        // Clear the form
        clearForm();
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong, please try again.",
          timer: 930,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error submitting pickup request:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to submit pickup request. Please try again.",
        timer: 930,
        showConfirmButton: false,
      });
    }
  };

  const clearForm = () => {
    setAccode("");
    setOriginPincode("");
    setDestinationPincode("");
    setConsignor("");
    setConsignee("");
    setMobile1("");
    setNoOfBox("");
    setNoOfPieces("");
    setPickupsheetDate(new Date().toISOString().split("T")[0]);
    setDescription("");
    setOriginId("");
    setOriginPincodeHidden("");
    setDestinationId("");
    setDestinationPincodeHidden("");
    setConsignorList([]);
    setConsigneeList([]);
    setIsValidMobile(true);
    setIsValidOriginPincode(true);
    setIsValidDestinationPincode(true);
    setPickupsheetDate("");
    // Reset typeaheads
    if (originTypeaheadRef.current) {
      originTypeaheadRef.current.clear();
    }
    if (destinationTypeaheadRef.current) {
      destinationTypeaheadRef.current.clear();
    }
  };

  const isFormValid = () => {
    return (
      accode &&
      originPincode &&
      destinationPincode &&
      consignor &&
      mobile1 &&
      noOfBox &&
      pickupsheetDate &&
      isValidMobile
    );
  };

  // Party validation function
  // Party validation function
  const validatePartyForm = () => {
    const newErrors = {};

    // Validate GSTIN - Optional but if provided should be valid format
    if (
      partyForm.gstNo &&
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(partyForm.gstNo)
    ) {
      newErrors.gstNo = "Invalid GSTIN format";
    }

    // Validate Party Name (Required)
    if (!partyForm.subAccountName || partyForm.subAccountName.trim() === "") {
      newErrors.subAccountName = "Party Name is required";
    }

    // Validate Pincode (Required, exactly 6 digits)

    // Validate Pincode (Required, exactly 6 digits) - Only if GST is not validated
    if (!partyForm.pinCode || !/^\d{6}$/.test(partyForm.pinCode)) {
      newErrors.pinCode = "Please enter a valid 6-digit pincode";
    }

    // Validate Address (Required) - Only if GST is not validated
    if (!partyForm.address1 || partyForm.address1.trim() === "") {
      newErrors.address1 = "Address is required";
    }

    // Validate City (Required)
    if (!partyForm.cityName || partyForm.cityName.trim() === "") {
      newErrors.cityName = "City is required";
    }

    // Validate State (Required)
    if (!partyForm.stateName || partyForm.stateName.trim() === "") {
      newErrors.stateName = "State is required";
    }

    // Validate Customer Category (Required)
    if (!partyForm.customerCategory || partyForm.customerCategory === "") {
      newErrors.customerCategory = "Customer Category is required";
    }

    // Validate Mobile Number (Required, exactly 10 digits)
    if (!partyForm.mobileNo || !/^\d{10}$/.test(partyForm.mobileNo)) {
      newErrors.mobileNo = "Please enter a valid 10-digit mobile number";
    }

    // Set errors in partyErrors state (instead of errors)
    setPartyErrors(newErrors);

    // Return true if no errors, false otherwise
    return Object.keys(newErrors).length === 0;
  };

  const validatePartyPincode = async (pincode) => {
    if (!pincode || pincode.length < 6) {
      setPartyErrors((prev) => ({
        ...prev,
        pinCode: "Please enter a valid 6-digit pincode",
      }));
      return false;
    }

    try {
      // First API - Get Area Name
      const response = await axios.get(`${API_BASE_URL}/common/cityListByPincode`, {
        params: {
          cid: sessionStorage.getItem("cid"),
          pincode,
        },
      });

      if (!(response.status === 200 && response.data?.length > 0)) {
        setPartyErrors((prev) => ({
          ...prev,
          pinCode: "Invalid pincode. Please enter a valid pincode.",
        }));

        setPartyForm((prev) => ({
          ...prev,
          cityName: "",
          stateName: "",
          areaName: "",
          districtName: "",
        }));

        return false;
      }

      const areaName = response.data[0].areaName || "";

      setPartyForm((prev) => ({
        ...prev,
        areaName,
      }));

      setPartyErrors((prev) => ({
        ...prev,
        pinCode: "",
      }));

      // Second API - Get District / State
      const response1 = await axios.get(`${API_BASE_URL}/common/getDistrictStateByPincode`, {
        params: {
          cid: sessionStorage.getItem("cid"),
          pincode,
          cityName: areaName,
        },
      });

      if (response1.status === 200 && response1.data?.length > 0) {
        const data1 = response1.data[0];

        setPartyForm((prev) => ({
          ...prev,
          stateName: data1.stateName || "",
          cityName: data1.cityName || "",
          districtName: data1.districtName || "",
        }));

        return true;
      }

      setPartyErrors((prev) => ({
        ...prev,
        pinCode: "No location details found for this pincode.",
      }));

      setPartyForm((prev) => ({
        ...prev,
        cityName: "",
        stateName: "",
        areaName: "",
        districtName: "",
      }));

      return false;
    } catch (error) {
      console.error("Error validating pincode:", error);

      setPartyErrors((prev) => ({
        ...prev,
        pinCode: "Error validating pincode. Please try again.",
      }));

      return false;
    }
  };

  const handleAddressSelect = (addr) => {
    setSelectedGstAddresses((prev) => {
      const exists = prev.some(
        (item) => item.pincode === addr.pincode && item.buildingNo === addr.buildingNo
      );
      if (exists) {
        return prev.filter(
          (item) => !(item.pincode === addr.pincode && item.buildingNo === addr.buildingNo)
        );
      } else {
        return [...prev, addr];
      }
    });
  };

  const handleBlurGstNo = async () => {
    if (!partyForm.gstNo || partyForm.gstNo.trim() === "") {
      return;
    }

    try {
      const exists = await validatePincodeAndGstExists(partyForm.pinCode, partyForm.gstNo);

      if (exists) {
        toast.error("Already Exists with Same GST No and Pincode!");

        setPartyForm((prev) => ({
          ...prev,
          subAccountName: "",
          pinCode: "",
          areaName: "",
          cityName: "",
          stateName: "",
          address1: "",
          mobileNo: "",
          customerCategory: "",
          gstNo: "",
        }));

        setPartyErrors({});
        return;
      }
    } catch (err) {
      console.error("Error validating GST No:", err);
      toast.error("Failed to validate GST No!");
    }
  };

  useEffect(() => {
    const checkDuplicate = async () => {
      if (partyForm.pinCode?.length === 6 && partyForm.gstNo?.trim()) {
        const exist = await validatePincodeAndGstExists(partyForm.pinCode, partyForm.gstNo);

        if (exist) {
          toast.error("Already Exists with Same GST No and Pincode!");

          setPartyForm((prev) => ({
            ...prev,
            subAccountName: "",
            pinCode: "",
            area: "",
            city: "",
            state: "",
            address: "",
            mobileNo: "",
            customerSubcategory: "",
            gstNo: "",
          }));

          setErrors({});
        }
      }
    };

    checkDuplicate();
  }, [partyForm.pinCode, partyForm.gstNo]);

  const validatePincodeAndGstExists = async (pincode, gstNo) => {
    if (!pincode?.trim() || !gstNo?.trim()) {
      return false;
    }

    try {
      const res = await axios.get(`${API_BASE_URL}/pickupReq/validatePincodeSubDebtor`, {
        params: {
          cid: cid, // Now cid is defined
          pincode: pincode,
          gstNo: gstNo,
        },
      });

      // If status is 1 Already exists
      if (res.data.status === 1) {
        toast.error(res.data.message);
        return true;
      }
      return false;
    } catch (err) {
      if (err.response && (err.response.status === 400 || err.response.status === 409)) {
        return true;
      }
      return false;
    }
  };

  const handleBlurPartyName = async () => {
    if (
      !partyForm.subAccountName ||
      partyForm.subAccountName.trim() === "" ||
      partyForm.pinCode.trim() === "" ||
      !partyForm.pinCode
    ) {
      return;
    }

    try {
      const res = await axios.get(`${API_BASE_URL}/pickupReq/validatePincodeSubDebtor`, {
        params: {
          cid: cid,
          pincode: partyForm.pinCode,
          partyName: partyForm.subAccountName,
        },
      });

      if (res.data.status === 1) {
        toast.error("Party Name already exists At this Pincode!");
        setPartyForm((prev) => ({
          ...prev,
          subAccountName: "",
        }));
      }
    } catch (err) {
      console.error("Error validating Party Name:", err);
    }
  };

  const validateDestinationPincode = async () => {
    if (!destinationPincode || destinationPincode.length !== 6) {
      setIsValidDestinationPincode(false);
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/common/getValidatePincode`, {
        params: {
          cid,
          pincode: destinationPincode,
        },
      });

      if (response.status === 200 && response.data > 0) {
        setIsValidDestinationPincode(true);
      } else {
        setDestinationPincode("");
        setIsValidDestinationPincode(false);
        toast.error("Invalid Pincode");
      }
    } catch (error) {
      toast.error("Invalid Pincode");
      setDestinationPincode("");
      setIsValidDestinationPincode(false);
      toast.error("Invalid Pincode");
    }
  };

  const handlePartySave = async (e) => {
    e.preventDefault();

    // Validate all fields first
    const isValid = validatePartyForm();

    if (!isValid) {
      toast.error("Please fix all validation errors");
      return;
    }

    try {
      // Check for duplicate GST + Pincode
      const exists = await validatePincodeAndGstExists(partyForm.pinCode, partyForm.gstNo);

      if (exists) {
        toast.error("Already Exists with Same GST No and Pincode!");
        setPartyForm((prev) => ({
          ...prev,
          subAccountName: "",
          pinCode: "",
          area: "",
          city: "",
          state: "",
          address: "",
          mobileNo: "",
          customerSubcategory: "",
          gstNo: "",
        }));
        setPartyErrors({});
        return;
      }

      const payload = {
        gstNo: partyForm.gstNo || "",
        subAccountName: partyForm.subAccountName,
        areaName: partyForm.areaName,
        pincode: partyForm.pinCode,
        address1: partyForm.address1,
        mobileNo: partyForm.mobileNo,
        customerCategory: partyForm.customerCategory,
        cid: cid,
        customerCode: getSessionStorage("accode"),
      };

      const response = await axios.post(
        `${API_BASE_URL}/pickupReq/saveSubMasterOperation`,
        payload
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Party Added Successfully",
          text: "The party has been added successfully.",
          timer: 2000,
          showConfirmButton: false,
        });

        setOpenModal(false);
        resetPartyForm();
        fetchCustomerList();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add party. Please try again.",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error saving party:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add party. Please try again.",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  // Blue color theme constants
  const blueTheme = {
    primary: "#1976d2",
    primaryLight: "#42a5f5",
    primaryDark: "#0d47a1",
    primaryGradient: "linear-gradient(135deg, #1976d2, #0d47a1)",
    bgLight: "#e3f2fd",
    bgDark: "#1a1a2e",
    textLight: "#ffffff",
    textDark: "#0d47a1",
    borderLight: "#90caf9",
    borderDark: "#1a237e",
  };

  // Handle modal close
  const handleModalClose = () => {
    setOpenModal(false);
    resetPartyForm();
  };

  const resetPartyForm = () => {
    setPartyForm({
      gstNo: "",
      subAccountName: "",
      pinCode: "",
      address1: "",
      cityName: "",
      districtName: "",
      areaName: "",
      stateName: "",
      customerCategory: "",
      mobileNo: "",
    });

    setPartyErrors({
      gstNo: "",
      subAccountName: "",
      pinCode: "",
      address1: "",
      cityName: "",
      districtName: "",
      areaName: "",
      stateName: "",
      customerCategory: "",
      mobileNo: "",
    });

    setSelectedGstAddresses([]);
  };

  // Modal styling
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: isDark ? "#1a1a1a" : "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    border: isDark ? "1px solid #333" : "none",
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        className={`mt-[24%] sm:mt-10 md:mt-0 lg:mt-0 2xl:mt-0 h-[80%] ${
          showSidebar
            ? "transition-all transition-slowest ease ml-20 lg:ml-[18%]"
            : "transition-all transition-slowest ease"
        }`}
      >
        <Card sx={{ p: 2, boxShadow: 3, marginTop: 3 }}>
          <MDBox component="form" onSubmit={handleSubmit} borderRadius="lg">
            {/* Customer Name Field with Add Party Link */}
            <MDBox mb={3}>
              <MDBox width={{ xs: "100%", sm: "65.70%" }}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Customer Name <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <FormControl fullWidth required sx={{ height: 45.6 }}>
                  <Select
                    displayEmpty
                    value={accode}
                    onChange={handleCustomerChange}
                    renderValue={(selected) => {
                      if (!selected) return <span>Select Customer</span>;
                      const customer = customerList.find((c) => c.value === selected);
                      return customer ? customer.label : selected;
                    }}
                    sx={{ height: 56 }}
                  >
                    <MenuItem value="" disabled sx={{ minHeight: 48 }}>
                      <span>Select Customer</span>
                    </MenuItem>
                    {customerList.map((customer) => (
                      <MenuItem key={customer.value} value={customer.value} sx={{ minHeight: 48 }}>
                        {customer.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            </MDBox>

            {/* Pickup Details Section */}
            <MDTypography variant="h6" fontWeight="bold" color="info" sx={{ mt: 2 }}>
              Pickup Details
            </MDTypography>

            <MDBox display="flex" flexWrap="wrap">
              {/* Origin Pincode */}
              <MDBox width={{ xs: "100%", sm: "33.33%" }} pr={{ sm: 2 }} mb={2}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Org. Pin Code <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <Typeahead
                  ref={originTypeaheadRef}
                  id="origin-pincode"
                  labelKey="pincode"
                  minLength={6}
                  options={originPincodes.map((item) => ({
                    pincode: item.originPincode,
                    area: item.area,
                    city: item.city,
                    state: item.statename,
                    id: item.id,
                    gstValue: item.gstvalue,
                    gstApp: item.gstapp,
                  }))}
                  placeholder="Pincode"
                  allowNew={false}
                  onInputChange={(text) => fetchPincodeSuggestions(text)}
                  onChange={(selected) => {
                    if (selected.length > 0) {
                      setOriginPincode(selected[0].pincode);
                      setOriginId(selected[0].id);
                      setOriginPincodeHidden(selected[0].pincode);
                      setIsValidOriginPincode(true);
                      // Fetch consignor list based on pincode
                      fetchConsignorList(selected[0].pincode);

                      setPickupBid(selected[0].id);

                      if (selected[0].id === 0 || selected[0].id === "0") {
                        Swal.fire({
                          icon: "warning",
                          title: "Branch Not Mapped",
                          text: "This pincode is not mapped with any branch.",
                        });

                        setOriginPincode("");
                        setDestinationId("");
                        setOriginPincodeHidden("");
                        setPickupBid("");

                        setConsignorList([]);
                        setConsignor("");
                        setMobile1("");
                        setConsignorName("");

                        originTypeaheadRef.current?.clear();
                        return;
                      }
                    } else {
                      setOriginPincode("");
                      setOriginId("");
                      setOriginPincodeHidden("");
                      setConsignorList([]);
                      setPickupBid("");

                      setConsignorList([]);
                      setConsignor("");
                      setMobile1("");
                      setConsignorName("");
                    }
                  }}
                  selected={
                    originPincode
                      ? [
                          {
                            pincode: originPincode,
                            id: originId,
                            area: "",
                            city: "",
                            state: "",
                            gstValue: "",
                            gstApp: "",
                          },
                        ]
                      : []
                  }
                  onBlur={() => {
                    const isValid = originPincodes.some(
                      (item) => item.originPincode === originPincode
                    );
                    if (!isValid) {
                      setOriginPincode("");
                      setOriginId("");
                      setOriginPincodeHidden("");
                      setConsignorList([]);
                      setPickupBid("");
                      setConsignorList([]);
                      setConsignor("");
                      setMobile1("");
                      setConsignorName("");
                      originTypeaheadRef.current.clear();

                      toast.error("Please select a valid Pincode!");
                    }
                  }}
                  className={isValidOriginPincode ? "" : "is-invalid"}
                  style={{ height: "45.6px" }}
                />
                {!isValidOriginPincode && (
                  <MDTypography variant="caption" color="error">
                    Please select a valid pincode
                  </MDTypography>
                )}
              </MDBox>

              {/* Consignor */}
              <MDBox width={{ xs: "100%", sm: "33.33%" }} px={{ sm: 1 }} mt={1}>
                <MDBox display="flex" alignItems="center" mb={1}>
                  <MDTypography variant="caption" fontWeight="medium" color="text">
                    Consignor <span style={{ color: "red" }}>*</span>
                  </MDTypography>

                  <MDButton
                    variant="text"
                    color="info"
                    size="small"
                    onClick={() => setOpenModal(true)}
                    startIcon={<FontAwesomeIcon icon={faPlusCircle} />}
                    sx={{
                      fontSize: "0.8rem",
                      textTransform: "none",
                      minWidth: "auto",
                      minHeight: "auto",
                      ml: 3,
                      p: 0,
                      "&:hover": {
                        backgroundColor: "rgba(33, 150, 243, 0.08)",
                      },
                    }}
                  >
                    Add New
                  </MDButton>
                </MDBox>
                <FormControl fullWidth required sx={{ height: 45.6, mb: 2 }}>
                  <Select
                    id="consignor"
                    displayEmpty
                    value={consignor}
                    onChange={(e) => {
                      const selectedValue = e.target.value;

                      // selectedValue = subCode
                      const selectedConsignor = consignorList.find(
                        (item) => item.subCode === selectedValue
                      );

                      setConsignor(selectedValue);

                      if (selectedConsignor) {
                        // setConsignorName(selectedConsignor.acName);
                        fetchConsignorMobile(selectedConsignor.subCode);
                      }
                    }}
                    renderValue={(selected) => {
                      if (!selected) return <span>Select Consignor</span>;

                      const item = consignorList.find((c) => c.subCode === selected);

                      return item ? item.acName : selected;
                    }}
                    sx={{ height: 56 }}
                  >
                    <MenuItem value="" disabled>
                      Select Consignor
                    </MenuItem>

                    {consignorList.map((item) => (
                      <MenuItem key={item.subCode} value={item.subCode}>
                        {item.acName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>

              {/* Consignor Mobile */}
              <MDBox width={{ xs: "100%", sm: "33.33%" }} pl={{ sm: 2 }} mb={2}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Consignor Mobile <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <MDInput
                  type="text"
                  value={mobile1}
                  onChange={handleMobileChange}
                  placeholder="Mobile No (10 digits)"
                  fullWidth
                  required
                  error={!isValidMobile}
                  helperText={!isValidMobile && "Please enter a valid 10-digit mobile number."}
                  disabled={isMobileDisabled}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </MDBox>
            </MDBox>

            {/* Delivery Details Section */}
            <MDTypography variant="h6" fontWeight="bold" color="info" mb={2}>
              Delivery Details
            </MDTypography>

            <MDBox display="flex" flexWrap="wrap" mb={1}>
              {/* Destination Pincode */}
              <MDBox width={{ xs: "100%", sm: "33.33%" }} pr={{ sm: 2 }} mb={2}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Del. Pin Code <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <MDInput
                  type="text"
                  value={destinationPincode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setDestinationPincode(value);
                    setIsValidDestinationPincode(true);
                  }}
                  onBlur={validateDestinationPincode}
                  placeholder="Enter Pincode"
                  fullWidth
                  error={!isValidDestinationPincode}
                  inputProps={{ maxLength: 6 }}
                />

                {!isValidDestinationPincode && (
                  <MDTypography variant="caption" color="error">
                    Please enter a valid pincode.
                  </MDTypography>
                )}
                {/* {!isValidDestinationPincode && (
                  <MDTypography variant="caption" color="error">
                    Please select a valid pincode
                  </MDTypography>
                )} */}
              </MDBox>

              {/* Pcs (No of Pieces) - FIXED: Only numbers allowed */}
              <MDBox width={{ xs: "100%", sm: "32.60%" }} pl={{ sm: 1 }}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  No. Of Pcs <span style={{ color: "red" }}></span>
                </MDTypography>
                <MDInput
                  type="number"
                  value={noOfPieces}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Only allow positive integers
                    if (value === "" || (Number(value) >= 1 && Number.isInteger(Number(value)))) {
                      setNoOfPieces(value);
                    }
                  }}
                  placeholder="Number of pieces"
                  fullWidth
                  required
                  inputProps={{
                    min: 1,
                    step: 1,
                    pattern: "[0-9]*",
                  }}
                  onKeyPress={(e) => {
                    // Only allow number keys
                    const charCode = e.which ? e.which : e.keyCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault();
                    }
                  }}
                />
              </MDBox>

              {/* Pcs (No of Box) - FIXED: Only numbers allowed */}
              <MDBox width={{ xs: "100%", sm: "34%" }} pl={{ sm: 3 }}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  No. Of Boxes <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <MDInput
                  type="number"
                  value={noOfBox}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (Number(value) >= 1 && Number.isInteger(Number(value)))) {
                      setNoOfBox(value);
                    }
                  }}
                  placeholder="Number of boxes"
                  fullWidth
                  required
                  inputProps={{
                    min: 1,
                    step: 1,
                    pattern: "[0-9]*",
                  }}
                  onKeyPress={(e) => {
                    // Only allow number keys
                    const charCode = e.which ? e.which : e.keyCode;
                    if (charCode < 48 || charCode > 57) {
                      e.preventDefault();
                    }
                  }}
                />
              </MDBox>

              <MDBox width={{ xs: "100%", sm: "32.10%" }} pl={{ sm: 0 }}>
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Pickup Date <span style={{ color: "red" }}>*</span>
                </MDTypography>
                <MDInput
                  type="date"
                  value={pickupsheetDate}
                  onChange={(e) => setPickupsheetDate(e.target.value)}
                  min={today}
                  fullWidth
                  required
                  inputProps={{
                    min: today,
                  }}
                />
              </MDBox>

              {/* Pickup Date and Special Instruction */}
              <MDBox
                width={{ xs: "100%", sm: "60%", lg: "67.60%", xl: "67.60%" }}
                mb={2}
                pl={{ sm: 3 }}
              >
                <MDTypography variant="caption" fontWeight="medium" color="text">
                  Special Instruction
                </MDTypography>
                <MDInput
                  type="text"
                  value={description}
                  onChange={(e) => {
                    const value = e.target.value
                      .toLowerCase()
                      .replace(/\b\w/g, (char) => char.toUpperCase());

                    setDescription(value);
                  }}
                  placeholder="Special instructions"
                  fullWidth
                  inputProps={{ maxLength: 999 }}
                />
              </MDBox>
            </MDBox>

            {/* Submit Button */}
            <MDBox display="flex" justifyContent="flex-start" mt={2}>
              <MDButton type="submit" variant="gradient" color="info" disabled={!isFormValid()}>
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      {/* Add Party Modal */}
      <Modal
        open={openModal}
        onClose={handleModalClose}
        aria-labelledby="add-party-modal"
        aria-describedby="add-party-form"
      >
        <Box sx={modalStyle}>
          <MDTypography variant="h6" fontWeight="bold" sx={{ mb: 3, color: blueTheme.primary }}>
            Add Party
          </MDTypography>

          <MDBox sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* GSTIN */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                GSTIN
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.gstNo}
                onChange={(e) => {
                  setPartyForm({ ...partyForm, gstNo: e.target.value.toUpperCase() });
                  setPartyErrors({ ...partyErrors, gstNo: "" });
                }}
                onBlur={handleBlurGstNo}
                placeholder="GST No"
                maxLength={20}
                error={!!partyErrors.gstNo}
                helperText={isLoadingGst ? "Fetching GST details..." : partyErrors.gstNo}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#ffffff" : "#0d47a1",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                    borderWidth: 2,
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* GST Addresses Table */}
            {/* {gstList.length > 0 && (
              <MDBox sx={{ mt: 2 }}>
                <MDTypography
                  variant="caption"
                  fontWeight="medium"
                  sx={{ color: isDark ? "#90caf9" : "#0d47a1", display: "block", mb: 1 }}
                >
                  GST Addresses
                </MDTypography>

                <Box
                  sx={{
                    overflowX: "auto",
                    border: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                    borderRadius: 1,
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      fontSize: "0.875rem",
                    }}
                  >
                    <thead
                      style={{
                        backgroundColor: isDark ? "#1a1a2e" : "#e3f2fd",
                        color: isDark ? "#90caf9" : "#0d47a1",
                      }}
                    >
                      <tr>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "left",
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                          }}
                        >
                          Add
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "left",
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                          }}
                        >
                          Pincode
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "left",
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                          }}
                        >
                          City
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "left",
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                          }}
                        >
                          Address
                        </th>
                        <th
                          style={{
                            padding: "8px 12px",
                            textAlign: "left",
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #90caf9",
                          }}
                        >
                          State
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {gstList.map((addr, index) => (
                        <tr
                          key={index}
                          style={{
                            borderBottom: isDark ? "1px solid #1a237e" : "1px solid #e3f2fd",
                            color: isDark ? "#ffffff" : "#0d47a1",
                          }}
                        >
                          <td style={{ padding: "8px 12px" }}>
                            <input
                              type="checkbox"
                              checked={selectedGstAddresses.some(
                                (item) =>
                                  item.pincode === addr.pincode &&
                                  item.buildingNo === addr.buildingNo
                              )}
                              onChange={() => handleAddressSelect(addr)}
                              style={{
                                accentColor: blueTheme.primary,
                              }}
                            />
                          </td>
                          <td style={{ padding: "8px 12px" }}>{addr.pincode}</td>
                          <td style={{ padding: "8px 12px" }}>{addr.district || addr.city}</td>
                          <td style={{ padding: "8px 12px" }}>
                            {[
                              addr.buildingNo,
                              addr.buildingName,
                              addr.street,
                              addr.location,
                              addr.locality,
                              addr.landMark,
                            ]
                              .filter(Boolean)
                              .join(", ")}
                          </td>
                          <td style={{ padding: "8px 12px" }}>{addr.state}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </MDBox>
            )} */}

            {/* Party Name */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                Party Name <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.subAccountName}
                onChange={(e) => {
                  setPartyForm({ ...partyForm, subAccountName: e.target.value });
                  setPartyErrors({ ...partyErrors, subAccountName: "" });
                }}
                placeholder="Sub A/C Name"
                maxLength={50}
                error={!!partyErrors.subAccountName}
                helperText={partyErrors.subAccountName}
                onBlur={handleBlurPartyName}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#ffffff" : "#0d47a1",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                    borderWidth: 2,
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* Pincode - Show only if GST is not validated */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                PinCode <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.pinCode}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPartyForm({ ...partyForm, pinCode: value });
                  setPartyErrors({ ...partyErrors, pinCode: "" });
                  if (value.length === 6) {
                    validatePartyPincode(value);
                  }
                }}
                placeholder="Pincode"
                maxLength={6}
                error={!!partyErrors.pinCode}
                helperText={partyErrors.pinCode}
                inputProps={{ maxLength: 6 }}
                onBlur={handleBlurPartyName}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#ffffff" : "#0d47a1",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                    borderWidth: 2,
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* Address - Show only if GST is not validated */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                Address <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                multiline
                rows={3}
                value={partyForm.address1}
                onChange={(e) => {
                  setPartyForm({ ...partyForm, address1: e.target.value });
                  setPartyErrors({ ...partyErrors, address1: "" });
                }}
                placeholder="Enter Address"
                maxLength={200}
                error={!!partyErrors.address1}
                helperText={partyErrors.address1}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#ffffff" : "#0d47a1",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                    borderWidth: 2,
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* City (Readonly) */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                City <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.cityName}
                placeholder="City"
                maxLength={30}
                InputProps={{
                  readOnly: true,
                }}
                error={!!partyErrors.cityName}
                helperText={partyErrors.cityName}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#90caf9" : "#0d47a1",
                    backgroundColor: isDark ? "#1a1a2e" : "#e3f2fd",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* State (Readonly) */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                State <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.stateName}
                placeholder="State"
                maxLength={30}
                InputProps={{
                  readOnly: true,
                }}
                error={!!partyErrors.stateName}
                helperText={partyErrors.stateName}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#90caf9" : "#0d47a1",
                    backgroundColor: isDark ? "#1a1a2e" : "#e3f2fd",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* Customer Category */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                Customer Category <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  value={partyForm.customerCategory}
                  onChange={(e) => {
                    setPartyForm({ ...partyForm, customerCategory: e.target.value });
                    setPartyErrors({ ...partyErrors, customerCategory: "" });
                  }}
                  renderValue={(selected) => {
                    if (!selected)
                      return (
                        <span style={{ color: isDark ? "#90caf9" : "#0d47a1" }}>
                          Select Customer Category
                        </span>
                      );
                    return selected;
                  }}
                  sx={{
                    height: 56,
                    color: isDark ? "#ffffff" : "#0d47a1",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: isDark ? "#1a237e" : "#90caf9",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: blueTheme.primary,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: blueTheme.primary,
                      borderWidth: 2,
                    },
                    "& .MuiSvgIcon-root": {
                      color: isDark ? "#90caf9" : "#0d47a1",
                    },
                  }}
                  error={!!partyErrors.customerCategory}
                >
                  <MenuItem value="" disabled sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}>
                    Select Customer Category
                  </MenuItem>
                  <MenuItem value="ShopKeeper" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    ShopKeeper
                  </MenuItem>
                  <MenuItem value="LFR" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    LFR
                  </MenuItem>
                  <MenuItem value="Modern Trade" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    Modern Trade
                  </MenuItem>
                  <MenuItem value="Cantt Area" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    Cantt Area
                  </MenuItem>
                  <MenuItem
                    value="Institutional Area"
                    sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}
                  >
                    Institutional Area
                  </MenuItem>
                  <MenuItem value="Mall Delivery" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    Mall Delivery
                  </MenuItem>
                  <MenuItem value="CFA Delivery" sx={{ color: isDark ? "#ffffff" : "#0d47a1" }}>
                    CFA Delivery
                  </MenuItem>
                </Select>
                {partyErrors.customerCategory && (
                  <MDTypography variant="caption" color="error" sx={{ mt: 1 }}>
                    {partyErrors.customerCategory}
                  </MDTypography>
                )}
              </FormControl>
            </MDBox>

            {/* Mobile No */}
            <MDBox>
              <MDTypography
                variant="caption"
                fontWeight="medium"
                sx={{ color: isDark ? "#90caf9" : "#0d47a1" }}
              >
                Mobile No. <span style={{ color: "red" }}>*</span>
              </MDTypography>
              <MDInput
                fullWidth
                value={partyForm.mobileNo}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  setPartyForm({ ...partyForm, mobileNo: value });
                  setPartyErrors({ ...partyErrors, mobileNo: "" });
                }}
                placeholder="Mobile No."
                maxLength={10}
                error={!!partyErrors.mobileNo}
                helperText={partyErrors.mobileNo}
                inputProps={{ maxLength: 10 }}
                sx={{
                  "& .MuiInputBase-input": {
                    color: isDark ? "#ffffff" : "#0d47a1",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: isDark ? "#1a237e" : "#90caf9",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: blueTheme.primary,
                    borderWidth: 2,
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#d32f2f",
                  },
                }}
              />
            </MDBox>

            {/* Action Buttons */}
            <MDBox display="flex" justifyContent="flex-end" gap={2} sx={{ mt: 2 }}>
              <MDButton
                variant="outlined"
                onClick={handleModalClose}
                sx={{
                  borderColor: blueTheme.primary,
                  color: blueTheme.primary,
                  "&:hover": {
                    borderColor: blueTheme.primaryDark,
                    backgroundColor: isDark
                      ? "rgba(25, 118, 210, 0.1)"
                      : "rgba(25, 118, 210, 0.05)",
                  },
                }}
              >
                Cancel
              </MDButton>
              <MDButton
                variant="contained"
                onClick={handlePartySave}
                sx={{
                  background: blueTheme.primaryGradient,
                  color: "#ffffff",
                  "&:hover": {
                    background: `linear-gradient(135deg, #1565c0, #0a3d91)`,
                  },
                }}
              >
                Save Party
              </MDButton>
            </MDBox>
          </MDBox>
        </Box>
      </Modal>
      <Toaster position="top-right" />
    </DashboardLayout>
  );
}

export default PickupRequest;
